<template>
	<!-- Create evaluation question -->
	<div class="container-evaluation-question">
		<ja-input
			v-model.trim="interestData.name"
			:label="$t('interestName')"
			:name="$t('interestName')"
			:disabled="!isEnable"
			@input="changeName()"
		></ja-input>
		<div v-show="showMessageError" class="error-msg">
			{{ $t('interestError') }}
		</div>
		<ja-dropdown
			v-model="statusIndex"
			:label="$t('status')"
			:disabled="!isEnable"
			:options="statusOptions"
			name="status"
		></ja-dropdown>

		<div class="container-buttons save">
			<ja-button
				v-if="isEnable"
				name="save"
				class="small outlined"
				:disabled="!isSaveCareer"
				@click.native="saveQuestion"
				>{{ $t('save') }}</ja-button
			>
			<ja-button name="cancel" class="small" @click.native="cancel">{{
				$t('cancel')
			}}</ja-button>
		</div>
	</div>
</template>
<script>
import Dropdown from '@/components/ui/form/Dropdown';
import Input from '@/components/ui/form/Input';
import Button from '@/components/ui/Button';
import { ID_NEW_CMS } from '@/helpers/constants';
import AdminFacility from '@/mixins/AdminFacility';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';
import InterestsService from '@/services/cms/InterestsService';

export default {
	components: {
		jaDropdown: Dropdown,
		jaButton: Button,
		jaInput: Input
	},
	mixins: [AdminFacility],
	props: {
		dataEdit: {
			type: Object,
			default: null,
			required: false
		},
		data: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			statusIndex: 0,
			statusOptions: [
				{ name: 'Active', isActive: true },
				{ name: 'Inactive', isActive: false }
			],
			interestData: null,
			showMessageError: false
		};
	},
	computed: {
		isSaveCareer() {
			return this.interestData.name !== null && this.interestData.name !== '';
		},
		isEnable() {
			return (
				(this.isSuperAdmin || this.isUSAAdmin) && this.selectedFacilityId == 0
			);
		}
	},
	watch: {
		statusIndex(newIndex) {
			this.interestData.isActive = this.statusOptions[newIndex].isActive;
		}
	},
	created() {
		this.interestData = this.dataEdit;
		this.setInitialIndex();
	},
	methods: {
		setInitialIndex() {
			if (this.interestData.interest_ID === ID_NEW_CMS) {
				this.statusIndex = this.statusOptions.findIndex(
					option => option.isActive === true
				);
				this.interestData.isActive = this.statusOptions[
					this.statusIndex
				].isActive;
			} else {
				this.statusIndex = this.statusOptions.findIndex(
					option => option.isActive === this.interestData.isActive
				);
			}
		},
		changeName() {
			if (this.interestData.name === '') {
				this.showMessageError = false;
			}
		},
		cancel() {
			this.$emit('cancel');
		},
		async saveQuestion() {
			const validateName =
				this.dataEdit != null &&
				(this.dataEdit.name != this.interestData.name ||
					this.dataEdit.interest_ID == ID_NEW_CMS);

			if (validateName) {
				const resp = await InterestsService.checkIfIsValidName(
					this.interestData.name
				);
				if (resp == false) {
					this.showMessageError = true;
					return;
				}
			}
			this.showMessageError = false;
			this.$emit('save-question', this.interestData);
		}
	}
};
</script>
<style lang="scss" scoped>
.container-evaluation-question {
	display: flex;
	flex-direction: column;
	gap: 20px;
}
.container-buttons {
	margin: 15px 0 10px 0;
	display: flex;
	align-items: center;
	gap: 20px;
}
.questions {
	justify-content: flex-start;
}
.save {
	justify-content: flex-end;
}
.box-businesses {
	border: 1px solid $button-border;
	width: 50%;
	height: 250px;
	padding: 15px;
	overflow: auto;
}
.option-businesses {
	display: flex;
	gap: 10px;
	margin: 5px;
}
.heading-5 {
	color: $font-dark;
}
.text-button {
	color: $link-font-color;
}
.text-label {
	margin: 10px 0 10px 0;
}
</style>
